import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class SidebarCartService {
  private sidebarVisible = new BehaviorSubject<boolean>(false);
  sidebarVisibility$ = this.sidebarVisible.asObservable();

  constructor() {}

  toggleSidebar(): void {
    console.log("📢 Toggling sidebar, current state:", this.sidebarVisible.value);
    this.sidebarVisible.next(!this.sidebarVisible.value);
  }

  openSidebar(): void {
    console.log("📢 Abrindo sidebar!");
    this.sidebarVisible.next(true);
  }

  closeSidebar(): void {
    console.log("📢 Fechando sidebar!");
    this.sidebarVisible.next(false);
  }
}
